import { ActivityIndicator } from 'react-native';
import { useTheme } from '../../lib/useTheme';

export const Loader = ({
  size = 'small',
  color,
}: {
  size?: number | 'small' | 'large';
  color?: string;
}) => {
  const theme = useTheme();
  return <ActivityIndicator size={size} color={color ?? theme.primary} />;
};
